import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  select: {
    backgroundColor: '#eceff1',
  },
  info: {
    color: '#546e7a',
    fontSize: 12,
    marginBottom: theme.spacing(2.5),
  },
  infoIcon: {
    fontSize: 15,
    marginBottom: -4,
  },
  radioItem: {
    border: '1px solid #dfdfdf',
    backrgound: 'white',
    boxSizing: 'border-box',
    display: 'block',
    padding: theme.spacing(1, 2),
    marginInlineStart: 0,
    transition: 'ease .2s background',
    '&.active': {
      background: theme.palette.primary.main,
      borderColor: theme.palette.primary.main,
      color: 'white',
    },
    '&:first-child': {
      borderTopLeftRadius: 4,
      borderBottomLeftRadius: 4,
      borderRight: 'none',
    },
    '&:last-child': {
      borderTopRightRadius: 4,
      borderBottomRightRadius: 4,
      borderLeft: 'none',
    },
  },
  radioText: {
    color: '#2b3940',
    fontSize: 14,
    display: 'inline-block',
    transition: 'ease .2s color',
    fontWeight: 'bold',
    '&.active': {
      color: 'white',
    },
  },
  options: {
    '& label': {
      margin: 0,
    },
  },
}));